import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef } from "@angular/material/dialog";

@Component({
    selector: 'app-master-data-load-log-popup',
    templateUrl: './master-data-load-log-popup.component.html',
    styleUrls: ['./master-data-load-log-popup.component.scss'],
    standalone: false
})
export class MasterDataLoadLogPopupComponent implements OnInit {

  constructor(private dialogref: MatDialogRef<MasterDataLoadLogPopupComponent>) { }

  ngOnInit() {
  }

  yes() {

    console.log("yes");

    this.dialogref.close("Yes");

  }

  no() {

    console.log("no");

    this.dialogref.close("No");

  }

}
